import {
  AfterContentInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import {
  AutocompleteComponent,
  AutocompleteLoadingModeType,
  IAutocompleteSchema,
  ToastService
} from "maps-angular-components";
import { FormBuilder, FormControl, FormGroup } from "@angular/forms";

import { Associacao } from "../../associacao/associacao-stepper/associacao";
import { AutocompleteItem } from "../../shared/models/autocomplete.model";
import { Regra } from "../regra";
import { RegraService } from "../regra.service";

@Component({
  selector: "selecao-regras",
  templateUrl: "./selecao-regras.component.html",
  styleUrls: ["./selecao-regras.component.scss"],
})
export class SelecaoRegrasComponent implements OnInit, AfterContentInit {
  @Input() form: FormGroup;

  @Input() buscaRegraComposta = false;
  @Input() associacao = false;

  @Input() isConsulta = false;

  @Input() regra;

  @ViewChild("selecaoRegrasRegra", { static: false })
  selecaoRegrasRegra: AutocompleteComponent<Regra>;

  @ViewChild('formDirective')
  formDirective;

  private page: any = 1;
  regras: Regra[] = [];
  regraSchema: IAutocompleteSchema<Regra>;
  @Output() onRegraChange: EventEmitter<Regra[]> = new EventEmitter<Regra[]>();
  private regraHolder: Regra;

  constructor(
    public regraService: RegraService,
    private readonly messageService: ToastService,
    private readonly changeDetectorRef: ChangeDetectorRef,
    private readonly formBuilder: FormBuilder
  ) {}

  ngOnInit() {

    this.form = this.formBuilder.group({
      regra: new FormControl(),
    });

    let endpoint;
    let label;

    if(this.buscaRegraComposta){
      label = "Regra (Regra simples / Regra composta)"
      endpoint = "autocomplete"
    }else{
      label = "Regra (Regra simples)";
      endpoint = "autocomplete/simples";
    }

    this.regraSchema = {
      service: this.regraService,
      endpoint,
      label,
      required: true,
      placeholder: "Regra selecionada",
      loadingMode: AutocompleteLoadingModeType.LAZY,
      autoload: false,
      formGroup: this.form,
      formControlName: "regra",
      panelClass: "w-100",
      parseSearchParam(search): string {
        return search;
      },
    };


  }

  ngAfterContentInit(): void {
    if (this.regra) {
      this.regra.regrasAssociadas.map(r => {
        this.regraHolder = r;
        this.adicionarRegra();
      });
    }
  }

  adicionarRegra() {

    if (!this.regraHolder) return;

    if (
      this.regras.some(
        (value) => this.regraHolder.id === value.id
      )
    ) {
      this.messageService.alerta("Regra já selecionada.");
      return;
    }

    this.regraService.addRegra(this.regraHolder, this.regras);

    this.selecaoRegrasRegra?.reset();
    this.form.reset();
    this.formDirective?.resetForm();

    this.regraHolder = null;
    this.changeDetectorRef.detectChanges();
    this.onRegraChange.emit(this.regras);

    this.markAsPending();
  }

  remove(s: any) {
    this.regraService.removerRegra(s, this.regras);
    this.onRegraChange.emit(this.regras);
  }

  receiverPage(e: any) {
    this.page = e;
  }

  getRegrasTotalPage() {
    const number = Math.ceil(this.regras.length / 10);
    if (number === 0) {
      return 1;
    }
    return number;
  }

  getRegrasPaging() {
    return this.regraService.getRegras(this.page, this.regras);
  }

  markAsPending(): void {
    Object.keys(this.form.controls).forEach(field => {
      const control = this.form.get(field);
      if (control instanceof FormControl) {
        control.markAsPending();
      }
    });
  }

  clear() {
    this.selecaoRegrasRegra.reset();
    this.form.reset();
    this.formDirective.resetForm();
    this.regras = [];
    this.markAsPending();
  }

  adequarEAdicionar(value: Associacao) {
    const item: AutocompleteItem = {
      id: value.regraId+'',
      name: value.regra,
    };
    value.regra = item;
    this.adicionarRegra();
  }

  regraSelecionada(regra: Regra) {
    this.regraHolder = regra;
  }
}
